import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string | string[]
}

class SetLiveRoomOnApi extends Service {
  constructor({ roomId }: DataType) {
    super()
    this.name = 'SET_LIVE_ROOM_ON'

    this.config = {
      url: `/v1/room/live/${roomId}`,
      method: 'PATCH',
    }
  }
}

export const setLiveRoomOn = (data: DataType) => getCallApiFunction(new SetLiveRoomOnApi(data))
